// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__HWLqx","popup":"style_popup__pElo3","pipette":"style_pipette__Rv86W","icon":"style_icon__+rQci"};